import { isNil } from 'ramda'
import { formatCurrency } from './formatCurrency'

export function formatValorLote(valor?: number, naLabel?: string): string {
  return isNil(valor) ? `${naLabel || 'Não Informado'}` : formatCurrency(valor)
}
